export default {
    "study_guide.title": "Official Study Guide",
    "study_guide.subtitle": "Prepare effectively with all the content needed to pass your exam.",
    "study_guide.train_now": "Train Now",
    "study_guide.back_home": "Back to Home",
    "study_guide.learn_title": "What you will learn",

    "study_guide.chapters": [
        "Canadian values and symbols",
        "History and geography of Canada",
        "Political and governmental system",
        "Rights and responsibilities of citizens",
        "The Canadian justice system",
        "Regions of Canada and its characteristics"
    ],

    "study_guide.cta.title": "Ready for the big day?",
    "study_guide.cta.desc": "Join CitoyenPro today and master all the content of the official guide with our adaptive quizzes.",
    "study_guide.cta.button": "Start for free",

    "study_guide.footer.copyright": "© 2025 CitoyenPro. All rights reserved.",
    "study_guide.footer.privacy": "Privacy",
    "study_guide.footer.terms": "Terms"
};
